var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 28.0938C22.0071 28.0938 27.6875 22.4134 27.6875 15.4062C27.6875 8.39914 22.0071 2.71875 15 2.71875C7.99289 2.71875 2.3125 8.39914 2.3125 15.4062C2.3125 17.6817 2.91153 19.8173 3.96049 21.6639L2.3125 28.0938L8.94159 26.5566C10.7419 27.5368 12.8059 28.0938 15 28.0938ZM15 26.1418C20.9291 26.1418 25.7356 21.3353 25.7356 15.4062C25.7356 9.47715 20.9291 4.67067 15 4.67067C9.0709 4.67067 4.26442 9.47715 4.26442 15.4062C4.26442 17.6955 4.98096 19.8174 6.20198 21.5599L5.24038 25.1659L8.90994 24.2485C10.6404 25.4426 12.7385 26.1418 15 26.1418Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8272 8.60938C11.5255 8.00348 11.0628 8.05712 10.5953 8.05712C9.75978 8.05712 8.45703 9.05788 8.45703 10.9204C8.45703 12.4468 9.12965 14.1177 11.3962 16.6172C13.5835 19.0294 16.4575 20.2773 18.8435 20.2348C21.2295 20.1923 21.7204 18.1391 21.7204 17.4457C21.7204 17.1384 21.5297 16.985 21.3983 16.9434C20.5852 16.5532 19.0856 15.8261 18.7444 15.6895C18.4032 15.5529 18.225 15.7376 18.1143 15.8382C17.8048 16.133 17.1915 17.0021 16.9815 17.1975C16.7714 17.393 16.4583 17.2941 16.328 17.2202C15.8486 17.0278 14.5485 16.4495 13.5123 15.445C12.2307 14.2027 12.1555 13.7752 11.9141 13.3948C11.7209 13.0904 11.8626 12.9036 11.9334 12.822C12.2095 12.5034 12.5908 12.0115 12.7617 11.7671C12.9327 11.5227 12.797 11.1515 12.7155 10.9204C12.3653 9.92627 12.0685 9.0941 11.8272 8.60938Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.48b425ad5421b6ecf14d14e888258cba.svg";
export { ForwardRef as ReactComponent };